import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import EventTable from '../../components/EventTable'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import { capitalize } from 'humanize-plus'
import { allowedIntegrations } from './constants'
import { ELOQUA_APP_ID, PARDOT_APP_ID } from 'constants/ResourcesConstants'
import { Icon } from '@driftt/tide-core-legacy'
import ACCESS from 'utils/Access'
import './style.styl'

class IntegrationEventLog extends Component {
  
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  componentWillMount() {
    const { integrationId } = this.props.params

    if (!allowedIntegrations.includes(integrationId)) {
      this.context.router.push('/settings2/integrations')
    }
  }

  getBackLinkUrl(integrationId) {
    switch (integrationId) {
      case 'eloqua':
        return `/settings/setup/eloqua`
      case 'pardot':
        return `/settings/setup/pardot`
      default:
        return `/settings/setup/${integrationId}`
    }
  }

  renderMarketoInfo() {
    if (!ACCESS.hasGates('HAS_MARKETO_SYNC_LIST')) {
      return null
    }

    return (
      <span className="integration-event-log--extra-info">
        <Icon name="info" height={14} />
        <span>Pro tip: If you’ve imported any Marketo lists, those logs are located in the Contacts tab.</span>
        <Link to="/contacts/imports/logs" className="integration-event-log--extra-info-link" target="_blank">
          View Marketo Import Logs
        </Link>
      </span>
    )
  }

  renderPardotInfo() {
    if (!ACCESS.hasGates('HAS_PARDOT_SYNC_LIST')) {
      return null
    }

    return (
      <span className="integration-event-log--extra-info">
        <Icon name="info" height={14} />
        <span>Pro tip: If you’ve imported any Pardot lists, those logs are located in the Contacts tab.</span>
        <Link to="/contacts/imports/logs" className="integration-event-log--extra-info-link" target="_blank">
          View Pardot Import Logs
        </Link>
      </span>
    )
  }

  render() {
    const { integrationId } = this.props.params
    const displayName = capitalize(integrationId, true)

    return (
      <div>
        <IntegrationBreadcrumb
          backLinkText={`${displayName} Integration`}
          backLinkUrl={this.getBackLinkUrl(integrationId)}
        />
        <header>
          <h2 className="integration-header">{displayName} Event Log</h2>
          <p>Here’s a view of what data are passing between {displayName} and Drift. We’ll report all events and errors in the table below up until the last 60 days.</p>
          {integrationId === 'marketo' && this.renderMarketoInfo()}
          {integrationId === 'pardot' && this.renderPardotInfo()}
        </header>
        <EventTable sourceId={integrationId} />
      </div>
    )
  }
}

export default IntegrationEventLog



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/IntegrationEventLog/index.js